import { asyncLoadScript } from "../helpers";
import { catchErrors, skipForDevelopment, skipForPrerender } from "shared/mechanics/decorators";
import { IPlugin } from "shared/mechanics/plugin";

declare global {
	interface Window { adsbygoogle: any; }
}

const clientId = process.env.REACT_APP_INTEGRATION_GOOGLE_ADS_CLIENT_ID!;

export enum GoogleAdsOrientation {
	Horizontal,
	Vertical
}

export interface IGoogleAdsPlugin extends IPlugin {
	render(blockId: string, containerElementId: string, orientation: GoogleAdsOrientation): void;
}

export class GoogleAdsPlugin implements IGoogleAdsPlugin {
	name: string = 'Google Ads';

	@catchErrors
	@skipForPrerender
	@skipForDevelopment
	init(): void {
		window.adsbygoogle = window.adsbygoogle || [];
		
		asyncLoadScript('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js');
	}

	@catchErrors
	@skipForPrerender
	@skipForDevelopment
	render(slotId: string, containerElementId: string, orientation: GoogleAdsOrientation): void {
		var g = document.createElement("ins");
		g.className = "adsbygoogle";
		
		g.setAttribute("data-ad-client", clientId);
		g.setAttribute("data-ad-slot", slotId);
		
		if (orientation === GoogleAdsOrientation.Vertical) {
			g.style.display = 'inline-block';
			g.style.width = '200px';
			g.style.height = '600px';
		}
		else {
			g.style.display = "block";
			g.setAttribute("data-ad-format",'horizontal');
		}

		document.getElementById(containerElementId)?.appendChild(g);
		window.adsbygoogle.push({});
	}
}